/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Title_ImportingInputs */



/**
* | output |
* | --- |
* | "Importing Project" |
*
* @param {Iframe_Remote_Title_ImportingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_title_importing = /** @type {((inputs?: Iframe_Remote_Title_ImportingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Title_ImportingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation du projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Importprojekt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione del progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проект импорта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importando Proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导入项目")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトのインポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आयात परियोजना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Projeto de Importação")
	return /** @type {LocalizedString} */ ("Importing Project")
});